import { TreinamentoFuncionario } from "../../../../rh/domain/models/treinamento_funcionario";
import { IGetAllTreinamentoFuncionarioUseCase } from "../../../presentation/useCases/read/get_all_treinamento_funcionario_use_case";
import { ITerceirizacaoRepository } from "../../repositories/terceirizacao_repository";

/**
 * GetAllTreinamentoFuncionarioUseCase
 */

export class GetAllTreinamentoFuncionarioUseCase implements IGetAllTreinamentoFuncionarioUseCase {
  constructor(private readonly repository: ITerceirizacaoRepository) { }

  async getAllTreinamentoFuncionario(
    cargos: number[],
    centroCustos: number[],
    FornecedorPesquisa?: number,
  ): Promise<TreinamentoFuncionario[]> {
    return await this.repository.getAllTreinamentoFuncionario(
      cargos,
      centroCustos,
      FornecedorPesquisa
    );
  }
}
